import { clsx } from "clsx";
import { SVGIconProps } from "../interface";
const iconSize: Record<string, string> = {
  8: "h-2",
  12: "h-3",
  16: "h-4",
  24: "h-6",
  32: "h-8",
  40: "h-10",
  48: "h-12",
  56: "h-14",
  80: "h-20",
  124: "h-30",
};
const SvgSadDoctor = ({ title, titleId, size = 16, className }: SVGIconProps) => {
  const sizeClass = iconSize[size];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 243 214"
      className={clsx(sizeClass, className)}
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#sad-doctor_svg__a)">
        <path
          fill="url(#sad-doctor_svg__b)"
          d="M17.838 151.988c0-57.047 46.246-103.293 103.293-103.293 57.047 0 103.293 46.246 103.293 103.293v65.664H17.838z"
        />
        <path
          fill="#FFB573"
          d="M54.172 85.349c-.122.478-.366.956-.854 1.315l-3.66 2.99a2.494 2.494 0 0 1-2.562.358l-3.66-1.674a27.312 27.312 0 0 1-9.395-6.816l-.854-.956c-1.464-1.674-1.22-4.185.488-5.62l3.782-3.109c1.464-1.196 3.66-1.196 5.124 0l4.392 3.707c0 .239 7.93 5.022 7.199 9.805"
        />
        <path
          fill="#E0E0E0"
          d="M56.49 87.262s-.244-3.468-1.22-5.38c-3.05-.599-10.858 5.739-11.834 8.37.61 1.434 4.392 4.423 4.392 4.423 2.318-2.63 6.832-5.62 8.662-7.413"
        />
        <path
          fill="#BECED3"
          d="M88.333 67.532c-1.098 3.587-2.196 7.175-3.416 10.762-1.22 3.587-2.44 7.174-3.66 10.642-1.22 3.467-2.562 7.054-4.026 10.283-.732 1.674-1.464 3.228-2.074 4.663-.366.718-.732 1.316-.976 1.794l-.244.239-.122.12s0 .119 0 0c.122-.12.244-.24.366-.24l.732-.597c.122-.12.488-.24.976-.359.488-.12.854 0 1.098 0 .366.119-.244.119-1.098-.478-1.708-.957-4.026-2.99-6.1-5.262-2.075-2.272-4.149-4.902-6.1-7.652a50.398 50.398 0 0 1-2.807-4.185l-1.342-2.153-1.22-2.032-15.495 7.892c.488.956.976 1.793 1.342 2.63l1.465 2.511 2.928 5.022c2.074 3.348 4.27 6.577 6.954 9.805 1.342 1.674 2.684 3.229 4.27 4.783 1.586 1.554 3.416 3.228 5.612 4.663s5.002 2.99 9.029 3.707c1.952.359 4.27.239 6.588-.239 2.196-.478 4.27-1.555 5.978-2.631.244-.119.488-.358.732-.598.488-.478.976-.837 1.342-1.315.366-.359.61-.717.976-1.076l.366-.478.366-.479.61-.956c.732-1.076 1.342-2.152 1.952-3.109 1.098-2.033 2.074-3.946 3.05-5.74 1.83-3.706 3.417-7.413 5.003-11.12 1.586-3.707 3.05-7.413 4.514-11a300.812 300.812 0 0 0 4.148-11.12z"
        />
        <path
          fill="#355A6B"
          d="M111.636 251.196c14.397-44.601 25.499-99.006 25.499-99.006l-43.19-4.185s-2.806 69.95-5.49 100.8C85.65 280.97 74.67 355.702 74.67 355.702l13.176 1.077c-.122.119 22.449-65.646 23.791-105.583"
        />
        <path
          fill="#000"
          d="m120.176 188.659 5.979 10.522a1006.486 1006.486 0 0 1-10.615 38.981c.61-20.806 2.806-44.72 4.636-49.503"
          opacity={0.2}
        />
        <path
          fill="#355A6B"
          d="M153.605 248.207c-.732-45.916 2.196-76.527-1.83-99.246l-39.529-.597s9.638 72.819 14.518 103.191c4.881 30.491 10.981 105.223 10.981 105.223h12.2c.122 0 10.737-73.058 3.66-108.571"
        />
        <path
          fill="#fff"
          d="M150.067 57.368c-13.908-1.674-33.917-1.555-47.338.717-6.832 1.196-12.2 6.696-13.176 13.393-2.806 19.849-.366 54.405 1.342 89.201 30.501 10.283 62.832-.12 62.832-.12 1.098-7.055-1.342-30.013-3.05-42.329 2.562-12.674 7.93-27.262 11.347-44.122 1.83-8.13-3.661-15.784-11.957-16.74"
        />
        <path
          fill="#2A4856"
          d="M115.662 61.674s.854 2.63 3.294 4.902c2.441 0 5.979-2.63 5.979-2.63s-1.342-3.827-3.294-4.544c-4.881 1.076-5.979 2.272-5.979 2.272"
        />
        <path
          fill="#2A4856"
          d="M121.274 65.141c-1.464-1.315-2.684-.837-2.684-.837-3.172 5.86-8.174 41.731-10.126 52.253.854 6.338 2.074 8.49 3.782 15.784 1.586-5.62 3.782-8.968 6.222-15.186-.732-7.653 1.708-42.448 2.806-52.014"
        />
        <path
          fill="#FFB573"
          d="m137.623 31.182-17.202 12.795c2.074 5.38 2.684 11-6.223 13.033-2.196 2.87 1.708 6.218 5.369 7.772 5.978-.717 14.396-2.63 18.056-7.652-1.22-3.707-1.586-17.936 0-25.948"
        />
        <path
          fill="#E19D61"
          d="m120.299 43.977.122-.12 9.638-7.174c.976 0 2.806-.12 2.074 6.576-.488 4.185-7.076 8.73-11.346 9.686 1.464-2.511.732-5.74-.488-8.968 0 0 0 .12 0 0"
        />
        <path
          fill="#263238"
          d="M108.708 15.757c-3.416 5.262-1.098 13.392 1.586 16.023 4.88-8.848 3.782-18.534-1.586-16.023"
        />
        <path
          fill="#FFB573"
          d="M136.159 21.137c.244 9.925.976 15.664-3.66 21.045-6.954 8.131-19.765 4.663-23.059-5.022-2.928-8.61-2.928-23.317 6.588-27.98 9.395-4.663 19.887 2.033 20.131 11.957"
        />
        <path
          fill="#263238"
          d="M133.719 28.91c-5.002-.478-6.466-8.968-3.416-15.664-6.222-1.554-12.323.957-16.471 2.511-4.148 1.555-10.37 1.794-10.37-3.348 2.196 1.196 6.344-.717 6.832-2.75-4.514.598-5.002-6.337-2.44-7.533 0 3.587 12.078 1.315 18.423-.837 12.078-4.185 19.032 2.63 15.372 8.848 9.395 4.544 3.66 13.393-3.782 20.328-1.83-1.076-4.148-1.555-4.148-1.555"
        />
        <path
          fill="#263238"
          d="M130.669 24.845c.732 6.696-18.667 10.163-21.961 9.924-.976 5.74-5.124 9.566-.976 13.153 3.904 3.468 18.544 4.544 23.669-2.75 5.124-7.294 1.098-19.73 1.098-19.73zM138.599 9.898c4.636.717 6.1-3.707 4.392-7.174 6.467 2.87 1.342 10.522-4.392 7.174"
        />
        <path
          fill="#FFB573"
          d="M140.795 28.074c-.61 2.391-2.196 4.185-4.026 5.261-2.684 1.555-4.758-.598-4.758-3.467.122-2.511 1.464-6.457 4.514-6.816 3.05-.359 5.002 2.272 4.27 5.022"
        />
        <path
          fill="#B2C4CB"
          d="m137.257 54.62 4.88 1.314c0 1.196-1.342 3.468-4.758 6.457-3.172 2.75-10.126 7.414-13.176 7.414.366-3.587-.732-8.729-2.44-10.523 3.904.24 11.59-2.032 15.494-4.663M121.641 59.281c-3.417 1.316-7.199 6.338-8.297 9.686-1.83-.957-3.782-7.773-2.684-12.077 1.464-.957 3.538-1.196 5.49-.957.244 1.435 1.342 3.11 5.491 3.348"
        />
        <path
          fill="#D4DEE2"
          d="M142.496 55.724c-12.201 16.023-15.122 108.422-8.289 189.014 17.934 2.99 35.991-22.001 35.991-22.001s-11.834-81.07-8.784-107.018c3.05-25.947 6.588-41.013 5.734-48.785-.854-7.533-15.868-9.894-24.652-11.21M111.352 56.271c-8.053 27.86-18.993 125.333-15.332 183.804-6.833-5.5-14.519-18.056-14.397-22.599.122-4.305 3.05-80.473 4.27-91.832.61-18.534.122-46.514 2.44-57.395 2.318-10.761 14.722-12.695 23.019-11.978"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M120.024 42.098c-.768.303-1.709-1.63-4.649-1.889-2.572-.225-4.204 1.483-4.906 1.051-.703-.431 1.392-3.21 5.067-2.888 3.675.323 5.255 3.424 4.488 3.726"
          clipRule="evenodd"
        />
        <path
          fill="#2A4856"
          d="m105.961 144.602 30.044-.907c3.018-.085 4.563-2.296 3.429-4.903l-18.947-43.664c-1.134-2.607-4.535-4.662-7.554-4.577l-30.044.907c-3.019.085-4.563 2.296-3.43 4.903l18.948 43.664c1.134 2.607 4.535 4.662 7.554 4.577"
        />
        <path
          fill="#fff"
          d="M105.613 144.794c-3.104 0-6.519-2.111-7.681-4.79L78.984 96.341c-.567-1.318-.524-2.608.114-3.614.694-1.091 2.012-1.729 3.642-1.786l30.044-.907c3.16-.099 6.703 2.055 7.879 4.79l18.948 43.664c.567 1.318.525 2.607-.113 3.613-.695 1.092-2.013 1.729-3.642 1.786l-30.045.907zm.184-.708v.354zl30.045-.907c1.388-.043 2.494-.567 3.061-1.46.51-.808.538-1.857.056-2.962l-18.947-43.663c-1.077-2.495-4.294-4.479-7.214-4.365l-30.044.907c-1.389.042-2.494.567-3.061 1.46-.51.807-.539 1.856-.057 2.961l18.948 43.664c1.077 2.494 4.294 4.45 7.213 4.365"
        />
        <path
          fill="#FFB573"
          d="M126.521 124.808c.244-.478.366-1.076.244-1.554l-.854-4.544c-.122-.837-.854-1.554-1.708-1.793l-3.904-.957c-3.783-.957-7.809-1.076-11.591-.478l-1.22.239c-2.196.359-3.66 2.511-3.172 4.663l.976 4.663a3.828 3.828 0 0 0 4.026 3.109l5.734-.239c-.122 0 9.029 1.196 11.469-3.109"
        />
        <path
          fill="#E0E0E0"
          d="M125.788 115.482s-3.294-1.196-5.49-1.196c-1.83 2.511.854 12.077 2.806 14.11 1.586 0 5.857-2.152 5.857-2.152-1.343-3.109-2.319-8.37-3.173-10.762"
        />
        <path
          fill="#D4DEE2"
          d="M146.285 73.511c1.342 3.468 2.684 7.055 4.026 10.523a369.919 369.919 0 0 1 3.783 10.642 205.418 205.418 0 0 1 3.294 10.522c.488 1.674.976 3.468 1.22 4.903.122.717.244 1.434.366 2.032v.598c0-.119 0-.239.122-.359l.244-.956c.122-.239.244-.478.366-.598s.122 0 0 .12c-.366.358-1.342.837-2.562 1.315-2.562.837-5.979 1.435-9.517 1.674-3.538.239-7.32.359-11.102.239-1.952-.12-3.782-.12-5.734-.359l-2.806-.239-2.685-.239-2.806 16.979c1.22.239 2.196.359 3.295.479l3.172.478c2.074.239 4.27.478 6.344.717 4.27.359 8.662.598 13.176.479 4.515-.12 9.151-.479 14.397-1.914 2.562-.717 5.368-1.793 8.418-3.706 1.464-.957 3.05-2.272 4.392-3.946 1.342-1.674 2.44-3.707 3.172-5.859v-.12c.122-.239.122-.598.244-.837.123-.598.245-1.196.245-1.913v-3.826c-.122-1.316-.245-2.511-.489-3.707-.366-2.272-.732-4.305-1.22-6.337-.854-4.066-1.952-7.892-3.05-11.838-1.098-3.826-2.196-7.653-3.416-11.36-1.22-3.826-3.295-8.53-4.637-12.357z"
        />
        <path
          fill="url(#sad-doctor_svg__c)"
          d="M146.285 73.511c1.342 3.468 2.684 7.055 4.026 10.523a369.919 369.919 0 0 1 3.783 10.642 205.418 205.418 0 0 1 3.294 10.522c.488 1.674.976 3.468 1.22 4.903.122.717.244 1.434.366 2.032v.598c0-.119 0-.239.122-.359l.244-.956c.122-.239.244-.478.366-.598s.122 0 0 .12c-.366.358-1.342.837-2.562 1.315-2.562.837-5.979 1.435-9.517 1.674-3.538.239-7.32.359-11.102.239-1.952-.12-3.782-.12-5.734-.359l-2.806-.239-2.685-.239-2.806 16.979c1.22.239 2.196.359 3.295.479l3.172.478c2.074.239 4.27.478 6.344.717 4.27.359 8.662.598 13.176.479 4.515-.12 9.151-.479 14.397-1.914 2.562-.717 5.368-1.793 8.418-3.706 1.464-.957 3.05-2.272 4.392-3.946 1.342-1.674 2.44-3.707 3.172-5.859v-.12c.122-.239.122-.598.244-.837.123-.598.245-1.196.245-1.913v-3.826c-.122-1.316-.245-2.511-.489-3.707-.366-2.272-.732-4.305-1.22-6.337-.854-4.066-1.952-7.892-3.05-11.838-1.098-3.826-2.196-7.653-3.416-11.36-1.22-3.826-3.295-8.53-4.637-12.357z"
          opacity={0.7}
        />
        <path
          fill="#263238"
          d="M121.307 24.128c.035.95-.413 1.772-1.014 1.832-.601.06-1.114-.648-1.149-1.598-.035-.95.412-1.772 1.013-1.832.601-.06 1.115.648 1.15 1.598M110.461 25.535c.035.95-.413 1.772-1.014 1.832-.601.06-1.114-.649-1.149-1.599-.035-.95.412-1.772 1.013-1.832.601-.06 1.115.649 1.15 1.599"
        />
        <path
          fill="#ED893E"
          d="M113.793 26.74s-1.396 4.25-3.025 6.412c1.261 1.03 3.289.272 3.289.272z"
        />
        <path
          fill="#17282F"
          d="M111.239 20.66a.59.59 0 0 0-.461.168c-1.492 1.541-3.369 1.418-3.448 1.412-.288-.023-.547.159-.582.404-.034.245.169.462.455.487.104.007 2.507.188 4.378-1.744a.403.403 0 0 0-.064-.63zM119.014 19.184a.587.587 0 0 1 .46.168c1.492 1.541 3.37 1.418 3.449 1.412.288-.023.547.159.582.404.034.245-.169.463-.456.487-.104.007-2.507.188-4.377-1.744a.402.402 0 0 1 .064-.63z"
        />
        <path fill="url(#sad-doctor_svg__d)" d="M.5 0h242v213.963H.5z" />
      </g>
      <defs>
        <linearGradient
          id="sad-doctor_svg__b"
          x1={49.493}
          x2={102.39}
          y1={36.432}
          y2={207.368}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE3BD" />
          <stop offset={0.626} stopColor="#FFF4E5" />
        </linearGradient>
        <linearGradient
          id="sad-doctor_svg__c"
          x1={150.692}
          x2={150.692}
          y1={69.112}
          y2={107.906}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D4DEE2" stopOpacity={0} />
          <stop offset={1} stopColor="#B2C4CB" />
        </linearGradient>
        <linearGradient
          id="sad-doctor_svg__d"
          x1={121.5}
          x2={121.5}
          y1={134.928}
          y2={213.963}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0} />
          <stop offset={1} stopColor="#fff" />
        </linearGradient>
        <clipPath id="sad-doctor_svg__a">
          <path fill="#fff" d="M.5 0h242v213.963H.5z" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default SvgSadDoctor;
